import expiredLink from '../components/ExpiredLink/fr.i18n.json'
import pageNotFound from '../components/PageNotFound/fr.i18n.json'
import unexpectedError from '../components/UnexpectedError/fr.i18n.json'

export default {
  expiredLink,
  pageNotFound,
  unexpectedError,
}
